var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path5, _path6, _ellipse, _circle, _ellipse2, _path7, _rect9, _rect10, _rect11, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m692.054 349.078-.907 4.951c-7.751 41.772-36.35 75.257-75.128 85.896a97.006 97.006 0 0 1-15.231 2.917c-37.184 4.143-76.821-13.139-101.593-44.32-14.57-18.336-24.994-41.649-44.616-53.391-25.557-15.297-56.438-5.295-83.05 4.952-26.637 10.271-57.541 20.174-83.05 4.755-15.967-9.633-26.269-27.676-31.665-46.159-14.349-48.905 2.183-102.835 34.78-138.134 32.597-35.3 79.077-53.612 126.194-59.47 65.979-8.188 136.962 7.648 191.511 51.282 54.549 43.635 89.844 116.661 82.755 186.721z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.902 124.045c-21.78 0-39.437 17.656-39.437 39.437v8.974h353.638v-8.974c0-21.781-17.656-39.437-39.437-39.437H319.902zm314.201 99.331H280.465v214.87c0 21.78 17.657 39.437 39.437 39.437h274.764c21.781 0 39.437-17.657 39.437-39.437v-214.87z",
    fill: "#facc15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280.465 172.456h-14.788c0 8.167 6.621 14.789 14.788 14.789v-14.789zm353.638 0v14.789c8.168 0 14.789-6.622 14.789-14.789h-14.789zm0 50.92h14.789c0-8.168-6.621-14.789-14.789-14.789v14.789zm-353.638 0v-14.789c-8.167 0-14.788 6.621-14.788 14.789h14.788zm14.789-59.894c0-13.613 11.035-24.648 24.648-24.648v-29.578c-29.948 0-54.225 24.278-54.225 54.226h29.577zm0 8.974v-8.974h-29.577v8.974h29.577zm-14.789 14.789h353.638v-29.578H280.465v29.578zm338.849-23.763v8.974h29.578v-8.974h-29.578zm-24.648-24.648c13.613 0 24.648 11.035 24.648 24.648h29.578c0-29.948-24.278-54.226-54.226-54.226v29.578zm-274.764 0h274.764v-29.578H319.902v29.578zm314.201 69.753H280.465v29.578h353.638v-29.578zM295.254 438.246v-214.87h-29.577v214.87h29.577zm24.648 24.648c-13.613 0-24.648-11.036-24.648-24.648h-29.577c0 29.948 24.277 54.225 54.225 54.225v-29.577zm274.764 0H319.902v29.577h274.764v-29.577zm24.648-24.648c0 13.612-11.035 24.648-24.648 24.648v29.577c29.948 0 54.226-24.277 54.226-54.225h-29.578zm0-214.87v214.87h29.578v-214.87h-29.578z",
    fill: "#facc15"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 668.3,
    y: 466.301,
    width: 52.18,
    height: 6.079,
    rx: 3.04,
    transform: "rotate(-45 668.3 466.301)",
    fill: "#E1E4E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 688.307,
    y: 466.443,
    width: 19.375,
    height: 6.079,
    rx: 3.04,
    transform: "rotate(-45 688.307 466.443)",
    fill: "#E1E4E5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 238.81,
    y: 125.351,
    width: 33.993,
    height: 3.96,
    rx: 1.98,
    transform: "rotate(135 238.81 125.351)",
    fill: "#E1E4E5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 225.776,
    y: 125.258,
    width: 12.622,
    height: 3.96,
    rx: 1.98,
    transform: "rotate(135 225.776 125.258)",
    fill: "#E1E4E5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 196.979,
    y: 395.608,
    width: 46.128,
    height: 5.374,
    rx: 2.687,
    transform: "rotate(-45 196.979 395.608)",
    fill: "#E1E4E5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 214.665,
    y: 395.734,
    width: 17.128,
    height: 5.374,
    rx: 2.687,
    transform: "rotate(-45 214.665 395.734)",
    fill: "#E1E4E5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 698.044,
    y: 229.548,
    width: 43.102,
    height: 5.022,
    rx: 2.511,
    transform: "rotate(135 698.044 229.548)",
    fill: "#E1E4E5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 681.518,
    y: 229.43,
    width: 16.004,
    height: 5.022,
    rx: 2.511,
    transform: "rotate(135 681.518 229.43)",
    fill: "#E1E4E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m722.395 380.129-11.248-10.712 11.248-10.711 11.247 10.711-11.247 10.712z",
    stroke: "#E1E4E5",
    strokeWidth: 5.471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.424 295.773c0 5.919-4.798 10.711-10.724 10.711s-10.7-4.815-10.7-10.711c0-5.92 4.797-10.712 10.724-10.712 5.926 0 10.7 4.792 10.7 10.712z",
    stroke: "#E1E4E5",
    strokeWidth: 5.378,
    strokeMiterlimit: 10
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 382.828,
    cy: 148.961,
    rx: 10.181,
    ry: 10.521,
    transform: "rotate(105 382.828 148.961)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 10.726,
    transform: "scale(-1 1) rotate(75 -542.784 -296.98)",
    fill: "#facc15"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.592,
    ry: 5.394,
    transform: "scale(-1 1) rotate(75 -403.382 -316.052)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M225.808 190.447h.218c1.29 17.143 14.89 17.407 14.89 17.407s-14.997.275-14.997 20.084c0-19.809-14.996-20.084-14.996-20.084s13.594-.264 14.885-17.407zm451.026-40.834h.187c1.106 13.715 12.763 13.926 12.763 13.926s-12.854.22-12.854 16.067c0-15.847-12.854-16.067-12.854-16.067s11.652-.211 12.758-13.926z",
    fill: "#E1E4E5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 298.742,
    y: 474.477,
    width: 41.019,
    height: 4.779,
    rx: 2.389,
    transform: "rotate(-45 298.742 474.477)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 319.71,
    y: 474.477,
    width: 41.019,
    height: 4.779,
    rx: 2.389,
    transform: "rotate(-45 319.71 474.477)",
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 341.988,
    y: 474.477,
    width: 41.019,
    height: 4.779,
    rx: 2.389,
    transform: "rotate(-45 341.988 474.477)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M584.434 476.587c10.057.012 24.531-2.607 36.388-14.034 11.854-11.429 5.19-18.531-6.579-19.818-11.77-1.287-25.884 4.08-35.023 15.574-9.139 11.494-3.042 18.269 5.214 18.278z",
    fill: "url(#b)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m398.34 372.335-39.293-39.294 39.293-39.293m117.882 0 39.293 39.293-39.293 39.294m-43.694-98.23-32.751 117.88",
    stroke: "#fff",
    strokeWidth: 28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 462.874,
    y1: -78.512,
    x2: 470.689,
    y2: 807.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 637.595,
    y1: 480.347,
    x2: 546.095,
    y2: 428.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.1a53549a87d91bdd4a873e7d7fb43bfb.svg";
export { ForwardRef as ReactComponent };